module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_search-49ce41a2ce309ab18a12d7162f6a8619.svg";